@if (dynamicsInitialized) {
  <div>
    @if (!enabled) {
      <button (click)="upgrade()" routerLinkActive="active" mat-raised-button color="warn">
        {{ 'general.upgUseFeature' | transloco }}
      </button>
    }
    <br/>
    <br/>
    <br/>
    <dynamic-form #dynamicFormComponent [fields]="uiConfigInit" (submit)="submit($event)"></dynamic-form>
    <br/>
    <br/>
  </div>
}
